import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { useState } from "react";
import {
  DISPUTE_APIS,
  DISPUTE_APIS_PATHNAMES,
} from "../constants/disputes.apis";
import { useDisputeModal } from "../../AllTransaction/components/InitiateDisputeModal/store/useDisputeModal";
import {
  DISPUTE_HISTORY,
  DISPUTE_STATUS_ENUM,
} from "../constants/disputes.constant";

export const useDisputeHistory = () => {
  const setIsOpenDisputePaymentModal = useDisputeModal(
    (state) => state.setIsOpenDisputePaymentModal
  );
  const setIsOpenDisputeConfirmationModal = useDisputeModal(
    (state) => state.setIsOpenDisputeConfirmationModal
  );
  const setisOpenInitiateDisputeModal = useDisputeModal(
    (state) => state.setisOpenInitiateDisputeModal
  );
  const [orderId, setOrderId] = useState(null);

  const { data: disputePaymentStatusCheck } = useCustomQuery({
    queryKey: [DISPUTE_APIS.payment_status, orderId],
    url: DISPUTE_APIS_PATHNAMES.payment_status(orderId),
    enabled: !!orderId,
  });

  const { data: raisedDisputes, refetch: refetchRaisedDisputes } =
    useCustomQuery({
      url: DISPUTE_APIS.dispute_history,
      params: {
        status: `${DISPUTE_STATUS_ENUM.RAISED},${DISPUTE_STATUS_ENUM.ARBITRATIONRAISED}`,
      },
      queryKey: [DISPUTE_HISTORY],
    });

  const getMoreActions = ({ record }) => {
    if (!record) return;

    const moreActionList = [
      {
        label: "Accept Dispute",
        onClick: () => setIsOpenDisputeConfirmationModal(true),
      },
      {
        label: "Challenge Dispute",
        onClick: () => {},
      },
    ];

    if (record.status === DISPUTE_STATUS_ENUM.ARBITRATIONRAISED) {
      moreActionList[1].onClick = () => {
        setIsOpenDisputePaymentModal(true);
      };
    } else if (record.status === DISPUTE_STATUS_ENUM.RAISED) {
      moreActionList[1].onClick = () => {
        setisOpenInitiateDisputeModal(true);
      };
    }

    return moreActionList;
  };
  const getDisputeRecordByTransactionId = ({ transactionId }) => {
    return raisedDisputes?.page_data.find((dispute) => {
      return dispute?.transaction_uuid === transactionId;
    });
  };

  return {
    disputePaymentStatusCheck,
    refetchRaisedDisputes,
    setOrderId,
    getMoreActions,
    getDisputeRecordByTransactionId,
  };
};
